import { render, staticRenderFns } from "./edit-driver-email.vue?vue&type=template&id=10016e53&"
import script from "./edit-driver-email.vue?vue&type=script&lang=js&"
export * from "./edit-driver-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports